// @ts-nocheck

import { BetslipOptionsActionTypes } from '../types/actions/betslipOptions';

export type BetslipOptionsState = {
  [key: string]: {
    isFavorite?: boolean;
    isHidden?: boolean;
  };
};

export const betslipOptionsInitialState: BetslipOptionsState[] = {};

export default (state = betslipOptionsInitialState, action) => {
  switch (action.type) {
    case BetslipOptionsActionTypes.ADD_BET_TO_FAVORITES: {
      const { betslipId } = action.payload;
      return {
        ...state,
        [betslipId]: {
          ...state[betslipId],
          isFavorite: true,
        },
      };
    }

    case BetslipOptionsActionTypes.REMOVE_BET_FROM_FAVORITES: {
      const { betslipId } = action.payload;
      return {
        ...state,
        [betslipId]: {
          ...state[betslipId],
          isFavorite: false,
        },
      };
    }

    case BetslipOptionsActionTypes.HIDE_BET: {
      const { betslipId } = action.payload;
      return {
        ...state,
        [betslipId]: {
          ...state[betslipId],
          isHidden: true,
        },
      };
    }

    case BetslipOptionsActionTypes.REMOVE_HIDE_BET: {
      const { betslipId } = action.payload;
      return {
        ...state,
        [betslipId]: {
          ...state[betslipId],
          isHidden: false,
        },
      };
    }

    default:
      return state;
  }
};
